<script setup>
import colors from '@/assets/js/src/style/json/colors'
defineProps({
    size: {
        type: String,
        default: '36px',
    },
    monochrome: {
        type: Boolean,
        default: false,
    },
})
</script>

<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 600 600"
        class="niko-avatar"
    >
        <g v-if="!monochrome">
            <path
                d="M300.03,596c163.46,0,295.97-132.51,295.97-295.97S463.49,4.07,300.03,4.07,4.07,136.57,4.07,300.03s132.51,295.97,295.97,295.97"
                :fill="$vuetify.theme.current.dark ? colors.white : colors.bs"
            />
        </g>
        <g>
            <path
                :fill="monochrome ? 'currentColor' : ($vuetify.theme.current.dark ? colors.bs : colors.white)"
                d="M324.31,85.38c-2.01-14.47-15.77-24.41-30.16-21.46-10.58,2.16-17.46,8.73-19.91,19.23-2.41,10.36.9,19.1,9.12,25.89,3,2.49,6.54,3.94,10.3,4.88-.02,7.88-.04,15.76-.06,23.64h11.22c.04-3.34.12-6.69.12-10.04,0-4.58-.06-9.17-.09-13.75.45-.12.9-.24,1.35-.37,12.12-3.54,19.86-15.49,18.12-28.01M276.67,292.46c.03,17.7-14.15,31.94-31.83,31.95-17.6.02-31.9-14.21-31.91-31.74-.01-17.68,14.23-31.98,31.85-31.98,17.59,0,31.86,14.21,31.88,31.77M290.41,292.73c.12-25.03-20.2-46.15-46-46.13-25.42.02-46.04,20.63-46.01,46,.04,25.41,20.63,46,46.02,46s45.85-20.55,45.98-45.86M321.44,291.05c.08-16.76,13.56-31.55,31.93-31.57,17.73-.02,31.85,14.37,31.8,32.18-.05,17.41-14.42,31.6-31.94,31.55-17.76-.06-31.88-14.32-31.8-32.15M353.28,337.35c26.54.01,46.23-21.76,45.98-45.95.26-24.52-19.76-45.98-45.92-46.02-25.37-.04-45.85,20.51-46.01,45.81-.16,24.53,19.61,46.16,45.96,46.16M432.48,503.84c.87,0,1.75-.06,2.62.22,2.61.82,4.23,3.28,3.89,5.99-.32,2.61-2.48,4.59-5.16,4.74-.52.02-1.04.01-1.56.01H170.84c-.62,0-1.25.02-1.86-.03-2.82-.21-4.95-2.53-4.98-5.39-.02-2.85,2.09-5.24,4.87-5.51.62-.06,1.25-.03,1.87-.03h130.94c43.6,0,87.2,0,130.79,0M347.38,379.98h-94.73c-49.37,0-89.38-40.02-89.38-89.38s40.02-89.38,89.38-89.38h94.73c49.37,0,89.38,40.02,89.38,89.38s-40.02,89.38-89.38,89.38M163.08,553.87c-.02-2.85,2.09-5.24,4.87-5.51.62-.06,1.24-.03,1.86-.03,43.65,0,87.3,0,130.95,0s87.19,0,130.79,0c.88,0,1.75-.06,2.62.22,2.6.82,4.22,3.28,3.89,5.99-.32,2.61-2.47,4.59-5.16,4.74-.52.03-1.03.02-1.55.02H169.92c-.62,0-1.25.01-1.87-.03-2.82-.21-4.95-2.54-4.97-5.4M163.66,577.61c-.06-3.01,2.1-5.41,5.07-5.62.46-.04.93-.02,1.4-.02h262.05c.88,0,1.75-.02,2.62.25,2.52.82,4.19,3.34,3.86,5.88-.37,2.73-2.52,4.71-5.24,4.83-.62.02-1.25,0-1.87,0H170.57c-.57,0-1.14.01-1.71-.01-2.95-.12-5.16-2.38-5.21-5.31M438.99,532.09c-.32,2.61-2.48,4.59-5.16,4.74-.52.02-1.04.02-1.56.02H170.84c-.62,0-1.25.01-1.86-.03-2.82-.21-4.95-2.54-4.98-5.4-.02-2.85,2.09-5.24,4.87-5.51.62-.06,1.25-.02,1.87-.02,43.65,0,87.3,0,130.94,0s87.2,0,130.79,0c.87,0,1.75-.06,2.62.22,2.61.82,4.23,3.28,3.89,5.99M359.04,458.94v-31.2h72.2c28.72,0,52.01-23.29,52.01-52.01v-186.13c0-28.72-23.28-52.01-52.01-52.01H166.13c-28.72,0-52.01,23.29-52.01,52.01v186.13c0,28.72,23.28,52.01,52.01,52.01h86.29v31.2h-52.59c-28.72,0-52.01,23.28-52.01,52.01v3.69c-.26,0-.5-.02-.76-.02-47.58,0-86.83,35.46-92.89,81.38h491.7c-5.32-46.64-44.84-82.9-92.88-83.01v-2.04c0-28.72-23.28-52.01-52.01-52.01h-41.96Z"
            />
        </g>
    </svg>
</template>

<style scoped lang="scss">
.niko-avatar {
    display: block;
    width: v-bind(size);
    margin: 0 auto;
    overflow: hidden;
    border-radius: 9999px;
    aspect-ratio: 1 / 1;
}
</style>
